import { render, staticRenderFns } from "./SelectWallet.vue?vue&type=template&id=43bb55ec&scoped=true"
import script from "./SelectWallet.vue?vue&type=script&lang=js"
export * from "./SelectWallet.vue?vue&type=script&lang=js"
import style0 from "./SelectWallet.vue?vue&type=style&index=0&id=43bb55ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb55ec",
  null
  
)

export default component.exports